import React, { useEffect, useRef, useState } from 'react';
import { useEpisodeStore } from '../../../store';
import { GenericComment } from '../../../@types';
import {
  useCurrentUser,
  useAddResponseComment,
  useResponseComments,
} from '../../../api';

import { Chat } from '../../chat/Chat';

export const ResponseComments: React.FC<{
  promptId: string;
  responseId: string;
  isModerator: boolean;
  comments: GenericComment[];
  commentsLoading: boolean;
}> = ({ responseId, promptId, isModerator, comments, commentsLoading }) => {
  const { data: user } = useCurrentUser();
  const {
    mutateAsync: addResponseComment,
    isLoading,
  } = useAddResponseComment();

  const { getPromptStateById } = useEpisodeStore((state) => ({
    getPromptStateById: state.getPromptStateById,
    PROMPT_ACTIONS: state.PROMPT_ACTIONS,
    RESPONSE_ACTIONS: state.RESPONSE_ACTIONS,
  }));
  const state = getPromptStateById(promptId);
  const commentFeedRef = useRef<HTMLIonContentElement | null>(null);

  const scrollContent = () => {
    setTimeout(() => {
      if (commentFeedRef && commentFeedRef.current) {
        commentFeedRef.current.scrollToBottom(500);
      }
    }, 500);
  };

  useEffect(() => {
    scrollContent();
  }, [state.responsesOpen, comments]);

  async function onSubmitComment(_comment: string) {
    if (user) {
      await addResponseComment({
        response_id: responseId,
        user_id: user.id,
        comment: _comment,
      });
    }
  }

  return (
    <Chat
      onSubmit={onSubmitComment}
      comments={comments}
      isModerator={isModerator}
      type="responses"
      isLoading={isLoading || commentsLoading}
    />
  );
};
